import { axiosGet } from "./ajaxServices";
import { urlDashboardDetail } from "./CONSTANTS";
import api from "./api.js"

/**
 * Get homepage data for grid layout (NEW - December 2024)
 * Uses new HomepageController endpoint
 */
export const apiGetHomepageData = async (domain) => {
  const params = new URLSearchParams();
  params.append("domain", domain);
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };
  const tryEndpoint = async (endpoint) => {
    const { data } = await api.post(endpoint, params, config);
    return data;
  };

  // CI3 route-first approach (assumes baseURL may already include '/api/'), then controller fallbacks
  try {
    return await tryEndpoint("club/get_homepage_data_post");
  } catch (err1) {
    try {
      return await tryEndpoint("ClubHomePageController/get_homepage_data_post");
    } catch (err2) {
      return await tryEndpoint("HomepageController/get_homepage_data");
    }
  }
};

/**
 * Get registration info (OLD - kept for backwards compatibility)
 * @deprecated Use apiGetHomepageData instead for new grid homepage
 */
export const apiGetRegistrationInfo = async (domain) => {
  const params = new URLSearchParams();
  params.append("domain", domain);
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  const { data } = await api.post("admin/get_registration_info", params, config);

  return data;
};
export const apiGetRegistrationGroup = async () => {
  const params = new URLSearchParams();
  params.append("registration_id", 5);
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  const { data } = await api.post("mwuser/get_registration_group_camp", params, config);

  return data;
};

/**
 * Get toolbar items for a club by domain
 */
export const apiGetToolbarItems = async (domain) => {
  const params = new URLSearchParams();
  params.append("domain", domain);
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  const tryEndpoint = async (endpoint) => {
    const { data } = await api.post(endpoint, params, config);
    return data;
  };

  try {
    return await tryEndpoint("club/get_toolbar_items_post");
  } catch (err1) {
    return await tryEndpoint("ClubHomePageController/get_toolbar_items_post");
  }
};

export const apiGetMemberList = async (email, token) => {
  const params = new URLSearchParams();
  params.append("token", token);
  params.append("mail", email);

  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  const { data } = await api.post("mwuser/get_registration_member", params, config);

  return data;
};
